import request from "@/utils/request";

export const getUserInfo = (data: any) =>
    request({
        url: "/get_user_info",
        method: "post",
        data
    });

export const login = (data: any) =>
    request({
        url: "/login",
        method: "post",
        data
    });

export const logout = () =>
    request({
        url: "/logout",
        method: "post"
    });
